import React from 'react';
import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useAppDeployUpdate } from '@hooks/useAppDeployUpdate';

/**
 * Fixed banner when a new build is available (after upload). “Update” hard-reloads (cache clear + bust).
 */
export default function AppDeployUpdateBar() {
    const { updateAvailable, applyUpdate, isApplying } = useAppDeployUpdate();

    if (import.meta.env.DEV || !updateAvailable) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 16,
                left: 16,
                right: 16,
                zIndex: 10000,
                maxWidth: 560,
                margin: '0 auto',
                boxSizing: 'border-box',
            }}
        >
            <Alert
                type="info"
                showIcon
                message="A new version of the app is available."
                description="Update to load the latest changes from the server."
                action={
                    <Button
                        type="primary"
                        size="small"
                        icon={<ReloadOutlined />}
                        onClick={applyUpdate}
                        loading={isApplying}
                        disabled={isApplying}
                    >
                        Update
                    </Button>
                }
            />
        </div>
    );
}
